import { render, staticRenderFns } from "./CookiesDisclamer.vue?vue&type=template&id=1b40bdec&scoped=true&"
import script from "./CookiesDisclamer.vue?vue&type=script&lang=js&"
export * from "./CookiesDisclamer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40bdec",
  null
  
)

export default component.exports